import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';
import { Button } from '../Button';
import { InputWrapper } from '../InputWrapper';

export const MoreFiltersButton = styled(Button)`
  ${mediaQuery('tablet', 'min')} {
    display: none;
  }
`;

export const MobileButtonContainer = styled.div`
  display: flex;
  & > *:not(:last-child) {
    margin-right: 15px;
  }
  ${mediaQuery(420)} {
    flex-direction: column;
    & > * {
      width: 100%;
      &:not(:last-child) {
        margin-right: 0px;
        margin-bottom: 10px;
      }
    }
  }
`;

export const StyledInputWrapper = styled(InputWrapper)`
  &:not(:last-child) {
    margin-right: 15px;
  }
`;

export const ChildrenWrapper = styled.div`
  ${mediaQuery('tablet', 'max')} {
    display: none;
  }
`;
